<template>
	<a-table :columns="columns" :data-source="dataSource" class="components-table-demo-nested">
		<template #companyName="{ record }">
			<a @click="onCompanyDetail(record)">{{ record.companyName }}</a>
		</template>
		<template #expandedRowRender="{ record }">
			<a-table :columns="innerColumns" :data-source="record.label" size="small" :pagination="false">
				<template #jobTitle="{ record }">
					<a @click="onJobDetail(record)">
						<dict-render :dict-obj="dictObjs['hope_job']" :text="record.jobTitle"></dict-render>
					</a>
				</template>
				<template #industry="{ text }">
					<dict-render :dict-obj="dictObjs['research_field']" :text="text"></dict-render>
				</template>
				<template #educationBackground="{ text }">
					<dict-render :dict-obj="dictObjs['education_background']" :text="text"></dict-render>
				</template>
				<template #salary="{ text }">
					<dict-render :dict-obj="dictObjs['salary']" :text="text"></dict-render>
				</template>
				<template #workExperience="{ text }">
					<dict-render :dict-obj="dictObjs['work_experience']" :text="text"></dict-render>
				</template>
				<template #isShow="{ record }">
					<switch-btn :value="record.isShow" key-field="isShow" :switch-url="editUrl" :checkedValue="'0'"
						:uncheckedValue="'1'" :params="{ id: record.key }" @ok="loadData" />
				</template>
				<template #isPass="{ record }">
					<span>{{ record.isLaunch == 0 ? '未投递' : record.isLaunch == 1 ? '已投递' : '' }}</span>
				</template>
				<template #action="{ record }">
					<div class="table-row-operations">
						<a-popconfirm v-if="record.isLaunch == 0" title="确认要投递吗?" @confirm="onPass(record)">
							<a>投递</a>
						</a-popconfirm>
					</div>
				</template>
			</a-table>
		</template>
	</a-table>
	<DetailModal ref="detailModal" :form-primary-key-field="listKeyField" />
	<CompanyDetailModal ref="companydetailModal" :form-primary-key-field="listKeyField" />
</template>
<script>
import DetailModal from './components/DetailModal';
import CompanyDetailModal from './components/companyDetailModal'
import { dictMixin, tableListMixin } from "@/mixins";
import { jobRecommendationInfo, enterpriseRrecruitmentInfo, jobRecommendation } from "@/api/educationService";
import { companyInfo } from "@/api/companyService";
import DictRender from "@/components/other/DictRender";
import { dateFormat } from "@/config/variableConfig";
import { showCity } from "@/utils/util";
import { message } from "ant-design-vue";

const columns = [
	// {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
	{ title: "企业名称", dataIndex: "companyName", key: "companyName", slots: { customRender: "companyName" } },
	{ title: "详细地址", dataIndex: "detailedAddress", key: "detailedAddress" },
];
const innerColumns = [
	// {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
	{ title: "职位名称", dataIndex: "jobTitle", key: "jobTitle", slots: { customRender: "jobTitle" } },
	// { title: '行业类型', dataIndex: "industry", key: "industry", slots: { customRender: "industry" } },
	{ title: '学历', dataIndex: "educationBackground", key: "educationBackground", slots: { customRender: "educationBackground" } },
	{ title: '薪资', dataIndex: "salary", key: "salary", slots: { customRender: "salary" } },
	{ title: '工作经验', dataIndex: "workExperience", key: "workExperience", slots: { customRender: "workExperience" } },
	{ title: "招聘人数", dataIndex: "numberRecruits", key: "numberRecruits" },
	{ title: "投递状态", dataIndex: "isPass", key: "isPass", slots: { customRender: "isPass" } },
	{ title: "操作", dataIndex: "action", key: "action", slots: { customRender: "action" } },
];
export default {
	name: "index",
	mixins: [tableListMixin, dictMixin],
	components: {
		DetailModal, CompanyDetailModal, DictRender
	},
	data() {
		return {
			dateFormat,
			dictNames: 'research_field,education_background,salary,work_experience,hope_job',
			columns,
			innerColumns,
			queryParam: {},
			listUrl: jobRecommendationInfo.pageList,
			listKeyField: "id",
		}
	},
	methods: {
		onJobDetail(record) {
			this.getAction({
				url: enterpriseRrecruitmentInfo.detail,
				params: { id: record.id }
			}).then(res => {
				let obj = {
					...res,
					provject: res.prov ? showCity(res.prov, res.city, res.dist) : ''
				}
				this.onShowModal('detailModal', obj);
			})
		},
		onCompanyDetail(record) {
			this.getAction({
				url: companyInfo.detail,
				params: { companyCode: record.companyCode }
			}).then(res => {
				let obj = {
					...res,
					provject: res.prov ? showCity(res.prov, res.city, res.dist) : ''
				}
				this.onShowModal('companydetailModal', obj);
			})
		},
		onPass(record) {
			this.postAction({
				url: jobRecommendation.isPass,
				params: { id: record.id, companyCode: record.companyCode }
			}).then(() => {
				message.success("操作成功！")
				this.loadData()
			})
		}
	}
}
</script>